import { useGetCurrent } from '@BUP/hooks/Current/useGetCurrent'
import BupLoading from '@BUP/components/Loading/Main'

import React, { createContext } from 'react'

export const LocationContext = createContext()

// TODO: manage error
export const LocationContextProvider = ({ children }) => {
  const {
    data: locale,
    isLoading
  } = useGetCurrent('current-organization/location', 3)

  if (isLoading) return <BupLoading />
  if (!locale) return null

  return (
    <LocationContext.Provider value={locale}>
      {children}
    </LocationContext.Provider>
  )
}
